export default __webpack_public_path__ + "static/media/preenchimento.4e72cba3.jpg";